import { Grid, Paper, Typography, Button } from "@material-ui/core";
// Lib
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import classNames from "classnames";
import React from "react";
import { translate } from "react-i18next";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { styles } from "./styles";
import { dayOfWeek, version } from "../../../utils/setting";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
const timeBlock = [];
for (let i = 7; i <= 11; i++) {
  timeBlock.push(`${i}:00 AM`);
}
timeBlock.push(`12:00 PM`);
for (let i = 1; i <= 10; i++) {
  timeBlock.push(`${i}:00 PM`);
}

class EmployeeReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getPercentTotal = this.getPercentTotal.bind(this);
  }
  componentWillMount() {
    // this.props.getListEmployeeService()
  }
  getFormatDate = (date) => moment(date).format("DD/MM/YYYY");
  getDayOfWeek = () => {
    const { datetime } = this.props;
    let datesOfWeek = {
      sunday: [],
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
    };
    for (let i = 0; i < moment(datetime).daysInMonth(); i++) {
      let index = moment(datetime).add(i, "days").format("e");
      datesOfWeek[dayOfWeek[index]] = datesOfWeek[dayOfWeek[index]].concat(
        moment(datetime, "YYYYMM").add(i, "days").format("DD")
      );
    }
    return datesOfWeek;
  };
  getPercentInTime = (listOrder) => {
    const { listEmployee } = this.props;
    let res = 0;
    listOrder.forEach((order) => {
      let employees = [];
      let deduplicateEmployees = [];
      order.item.forEach((item) => {
        employees = employees.concat(item.employee);
      });
      employees.forEach((i) => {
        if (!deduplicateEmployees.find((e) => e.userCode === i.userCode)) {
          deduplicateEmployees.push(i);
        }
      });
      res += deduplicateEmployees.length / listEmployee.length;
    });

    return res / listOrder.length;
  };
  getPercent = (arrDay, fromTime, toTime) => {
    const { datetime, listOrders } = this.props;
    let result = 0;
    arrDay.forEach((day) => {
      let from = `${datetime} ${day}, ${fromTime}`;
      let to = `${datetime} ${day}, ${toTime}`;
      from = new Date(moment(from, "YYYYMM DD, h:mm a")).getTime();
      to = new Date(moment(to, "YYYYMM DD, h:mm a")).getTime();
      let ordersInTime = listOrders.filter((order) => {
        let processingTime = order.actionHistory.find(
          (item) => item.status == "new"
        );
        if (processingTime)
          return from < processingTime.time && processingTime.time < to;
        return false;
      });
      if (ordersInTime.length > 0)
        result += this.getPercentInTime(ordersInTime);
    });
    return result / arrDay.length;
  };
  getPercentTotal() {
    let args = Array.from(arguments);
    let res = 0;
    args = args.filter((item) => item > 0);
    args.forEach((item) => {
      res += item;
    });
    return res == 0 ? 0 : res / args.length;
  }
  renderTimeBlock = () => {
    const { classes, t } = this.props;
    let datesOfWeek = this.getDayOfWeek();
    let time = [];
    timeBlock.reduce((item1, item2) => {
      let monday = this.getPercent(datesOfWeek.monday, item1, item2);
      let tuesday = this.getPercent(datesOfWeek.tuesday, item1, item2);
      let wednesday = this.getPercent(datesOfWeek.wednesday, item1, item2);
      let thursday = this.getPercent(datesOfWeek.thursday, item1, item2);
      let friday = this.getPercent(datesOfWeek.friday, item1, item2);
      let saturday = this.getPercent(datesOfWeek.saturday, item1, item2);
      let sunday = this.getPercent(datesOfWeek.sunday, item1, item2);
      let total =
        (monday + tuesday + wednesday + thursday + friday + saturday + sunday) /
        7;
      // let total = this.getPercentTotal(monday, tuesday, wednesday, thursday, friday, saturday, sunday)
      time.push({
        duration: `${item1}-${item2}`,
        monday: monday,
        tuesday: tuesday,
        wednesday: wednesday,
        thursday: thursday,
        friday: friday,
        saturday: saturday,
        sunday: sunday,
        total: total,
      });
      return item2;
    });
    let totalAllTime = {
      sunday: 0,
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0,
      total: 0,
    };
    time.forEach((item) => {
      totalAllTime.monday += item.monday;
      totalAllTime.tuesday += item.tuesday;
      totalAllTime.wednesday += item.wednesday;
      totalAllTime.thursday += item.thursday;
      totalAllTime.friday += item.friday;
      totalAllTime.saturday += item.saturday;
      totalAllTime.sunday += item.sunday;
      totalAllTime.total += item.total;
    });
    for (let key in totalAllTime) {
      totalAllTime[key] /= time.length;
    }
    let rowTimeBlock = time.map((item, index) => {
      return (
        <Grid container spacing={24} key={index}>
          <Grid
            item
            xs={2}
            sm={2}
            md={2}
            className={classNames(classes.rowReportEmployee)}
          >
            <Grid container spacing={0}>
              <Grid
                className={classNames(classes.header)}
                item
                xs={12}
                sm={12}
                md={12}
              >
                <Typography
                  className={classNames(classes.textLeft, classes.fs14)}
                >
                  {item.duration}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={5}
            sm={5}
            md={5}
            className={classNames(classes.rowReportEmployee)}
          >
            <Grid container spacing={24}>
              <Grid
                className={classNames(classes.header)}
                item
                xs={3}
                sm={3}
                md={3}
              >
                <Typography
                  className={classNames(classes.textRight, classes.fs14)}
                >
                  {Math.round(item.monday * 100)} %
                </Typography>
              </Grid>
              <Grid
                className={classNames(classes.header)}
                item
                xs={3}
                sm={3}
                md={3}
              >
                <Typography
                  className={classNames(classes.textRight, classes.fs14)}
                >
                  {Math.round(item.tuesday * 100)} %
                </Typography>
              </Grid>
              <Grid
                className={classNames(classes.header)}
                item
                xs={3}
                sm={3}
                md={3}
              >
                <Typography
                  className={classNames(classes.textRight, classes.fs14)}
                >
                  {Math.round(item.wednesday * 100)} %
                </Typography>
              </Grid>
              <Grid
                className={classNames(classes.header)}
                item
                xs={3}
                sm={3}
                md={3}
              >
                <Typography
                  className={classNames(classes.textRight, classes.fs14)}
                >
                  {Math.round(item.thursday * 100)} %
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={5}
            sm={5}
            md={5}
            className={classNames(classes.rowReportEmployee)}
          >
            <Grid container spacing={24}>
              <Grid item xs={3} sm={3} md={3}>
                <Typography
                  className={classNames(classes.textRight, classes.fs14)}
                >
                  {Math.round(item.friday * 100)} %
                </Typography>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <Typography
                  className={classNames(classes.textRight, classes.fs14)}
                >
                  {Math.round(item.saturday * 100)} %
                </Typography>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <Typography
                  className={classNames(classes.textRight, classes.fs14)}
                >
                  {Math.round(item.sunday * 100)} %
                </Typography>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <Typography
                  className={classNames(classes.textRight, classes.fs14)}
                >
                  {Math.round(item.total * 100)} %
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    });
    rowTimeBlock.push(
      <Grid container spacing={24}>
        <Grid
          item
          xs={2}
          sm={2}
          md={2}
          className={classNames(classes.rowReportEmployee)}
        >
          <Grid container spacing={0}>
            <Grid
              className={classNames(classes.header)}
              item
              xs={12}
              sm={12}
              md={12}
            >
              <Typography
                className={classNames(
                  classes.textLeft,
                  classes.textBold,
                  classes.fs14
                )}
              >
                {t("report_total_all_time")}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={5}
          sm={5}
          md={5}
          className={classNames(classes.rowReportEmployee)}
        >
          <Grid container spacing={24}>
            <Grid
              className={classNames(classes.header)}
              item
              xs={3}
              sm={3}
              md={3}
            >
              <Typography
                className={classNames(
                  classes.textRight,
                  classes.textBold,
                  classes.fs14
                )}
              >
                {Math.round(totalAllTime.monday * 100)} %
              </Typography>
            </Grid>
            <Grid
              className={classNames(classes.header)}
              item
              xs={3}
              sm={3}
              md={3}
            >
              <Typography
                className={classNames(
                  classes.textRight,
                  classes.textBold,
                  classes.fs14
                )}
              >
                {Math.round(totalAllTime.tuesday * 100)} %
              </Typography>
            </Grid>
            <Grid
              className={classNames(classes.header)}
              item
              xs={3}
              sm={3}
              md={3}
            >
              <Typography
                className={classNames(
                  classes.textRight,
                  classes.textBold,
                  classes.fs14
                )}
              >
                {Math.round(totalAllTime.wednesday * 100)} %
              </Typography>
            </Grid>
            <Grid
              className={classNames(classes.header)}
              item
              xs={3}
              sm={3}
              md={3}
            >
              <Typography
                className={classNames(
                  classes.textRight,
                  classes.textBold,
                  classes.fs14
                )}
              >
                {Math.round(totalAllTime.thursday * 100)} %
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={5}
          sm={5}
          md={5}
          className={classNames(classes.rowReportEmployee)}
        >
          <Grid container spacing={24}>
            <Grid item xs={3} sm={3} md={3}>
              <Typography
                className={classNames(
                  classes.textRight,
                  classes.textBold,
                  classes.fs14
                )}
              >
                {Math.round(totalAllTime.friday * 100)} %
              </Typography>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <Typography
                className={classNames(
                  classes.textRight,
                  classes.textBold,
                  classes.fs14
                )}
              >
                {Math.round(totalAllTime.saturday * 100)} %
              </Typography>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <Typography
                className={classNames(
                  classes.textRight,
                  classes.textBold,
                  classes.fs14
                )}
              >
                {Math.round(totalAllTime.sunday * 100)} %
              </Typography>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <Typography
                className={classNames(
                  classes.textRight,
                  classes.textBold,
                  classes.fs14
                )}
              >
                {Math.round(totalAllTime.total * 100)} %
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
    return rowTimeBlock;
  };
  render() {
    const { classes, t, datetime, service } = this.props;
    let data = {
      from: new Date(moment(datetime).startOf("month").valueOf()),
      to: new Date(moment(datetime).endOf("month").valueOf()),
    };
    return (
      <React.Fragment>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={12} md={12} className={classes.content}>
            <Paper className={classes.rootLandscape}>
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12} md={6}>
                  <Typography className={[classes.textLeft]}>
                    {moment(new Date()).format("DD/MM/YYYY  h:mm A")}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Typography className={[classes.textRight]}>
                    Masspa {version}
                  </Typography>
                </Grid>
              </Grid>
              <hr className={[classes.breakLineReport]} />
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12} md={12}>
                  <Typography
                    className={classNames(classes.title, classes.textCenter)}
                  >
                    {t("report_employee_utilization_report")}
                  </Typography>
                  <Typography
                    className={classNames(classes.textCenter, classes.fs14)}
                  >
                    {t("report_report_for")}: {this.getFormatDate(data.from)} -{" "}
                    {this.getFormatDate(data.to)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={24}>
                <Grid item xs={2} sm={2} md={2}>
                  <Grid container spacing={0}>
                    <Grid
                      className={classNames(classes.header)}
                      item
                      xs={12}
                      sm={12}
                      md={12}
                    >
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textLeft,
                            classes.textBold,
                            classes.fs14
                          )}
                        >
                          {t("report_time_block")}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={5} sm={5} md={5}>
                  <Grid container spacing={24}>
                    <Grid
                      className={classNames(classes.header)}
                      item
                      xs={3}
                      sm={3}
                      md={3}
                    >
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textRight,
                            classes.textBold,
                            classes.fs14
                          )}
                        >
                          {t("report_monday")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid
                      className={classNames(classes.header)}
                      item
                      xs={3}
                      sm={3}
                      md={3}
                    >
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textRight,
                            classes.textBold,
                            classes.fs14
                          )}
                        >
                          {t("report_tuesday")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid
                      className={classNames(classes.header)}
                      item
                      xs={3}
                      sm={3}
                      md={3}
                    >
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textRight,
                            classes.textBold,
                            classes.fs14
                          )}
                        >
                          {t("report_wednesday")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid
                      className={classNames(classes.header)}
                      item
                      xs={3}
                      sm={3}
                      md={3}
                    >
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textRight,
                            classes.textBold,
                            classes.fs14
                          )}
                        >
                          {t("report_thursday")}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={5} sm={5} md={5}>
                  <Grid container spacing={24}>
                    <Grid item xs={3} sm={3} md={3}>
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textRight,
                            classes.textBold,
                            classes.fs14
                          )}
                        >
                          {t("report_friday")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textRight,
                            classes.textBold,
                            classes.fs14
                          )}
                        >
                          {t("report_saturday")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textRight,
                            classes.textBold,
                            classes.fs14
                          )}
                        >
                          {t("report_sunday")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <div className={classNames(classes.wrapBorder)}>
                        <Typography
                          className={classNames(
                            classes.textRight,
                            classes.textBold,
                            classes.fs14
                          )}
                        >
                          {t("report_total")}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {this.renderTimeBlock()}
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}
const mapState = (state) => ({
  listOrders: state.report.listOrders,
  totalOrder: state.report.totalOrder,
  setting: state.setting.setting,
  service: state.service.service,
  listEmployee: state.employees.employee,
});

const mapDispatch = (dispatch) => ({
  getListEmployeeService: dispatch.employees.getListEmployeeService,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(EmployeeReport)
  )
);
